const PORT = 3009;
let host = `${window.location.protocol}//${window.location.hostname}`;

let isLocalDevEnv = false;
if (window.location.hostname === "localhost") {
  isLocalDevEnv = true;
  host = `${host}:${PORT}`;
  host = "https://bihai.top";
}

const baseApiUrl = `${host}/api`;

const sampleChains = [
  {
    name: "零售体验店",
    chainId: "699c182342a38e0567ab9a4d",
  },
  {
    name: "美发体验店",
    chainId: "69e825bfd026dbcbb026c19c",
  },
  {
    name: "宠物店专业版测试店",
    chainId: "6a6201114597d44aac4746d1",
  },
  {
    name: "中餐馆专业版测试店",
    chainId: "6a619baabf9ced357cc4a89c",
  },
  {
    name: "便利店专业版测试店",
    chainId: "6a774598a04abc3749125181",
  },
  {
    name: "茶饮体验店",
    chainId: "691d7571f0b1d158f829f6a1",
  },
  {
    name: "烘焙体验店",
    chainId: "691d74cdf0b1d158f829f697",
  },
  {
    name: "餐饮体验店",
    chainId: "69759feec049903648189464",
  },
];

sampleChains.push({ name: "生鲜体验店", chainId: "6aafe0d8e76170bae29ae13c" });

if (isLocalDevEnv || window.location.hostname === "bihai.top") {
  sampleChains.push(
    {"name": "生鲜专业版测试店", "chainId": "33e51642d4c1520c3bdd6b73"},
    {"name": "服饰经营专业版测试店", "chainId": "9a386faf909a0c856d17dd7b"},
    {"name": "预订生产专业版测试店", "chainId": "43a74f3713e9cc67dd7334cf"},
    {"name": "机构供餐专业版测试店", "chainId": "d0fe6e2fc6e3f14a2caa69aa"},
  );
}

const SAMPLE_ID_MAP = Object.fromEntries(
  sampleChains.map((sample) => [sample.name, sample]),
);

const getSampleLogin = (sampleName) => {
  const sample = SAMPLE_ID_MAP[sampleName];
  return sample ? { name: sampleName, ...sample } : null;
};

const env = {
  host,
  baseApiUrl,
  isLocalDevEnv,
  sampleChains,
  SAMPLE_ID_MAP,
  getSampleLogin,
};

export default env;
